var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{attrs:{"autoplay":"true","muted":"muted","preload":"auto"},domProps:{"muted":true}},[_c('source',{attrs:{"src":_vm.webm,"type":"video/webm; codecs=\"vp8, vorbis\""}})])}
var staticRenderFns = []

export { render, staticRenderFns }